export default "__VITE_ASSET__GyjA5dTm__"